import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { testAction } from "./components.action";

function* mySaga() {
  yield takeEvery("UPDATE_TEST_STATE", testAction);
}

export default mySaga;
